/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.cadeaux.ts
 *
 * Messages du jeu des CADEAUX (2026-10-05) : la roue après l'envoi d'un
 * questionnaire, la carte « Mon cadeau », le back-office « Cadeaux » et le
 * point de contrôle de remise des lots. Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement ni « salon »,
 * « atelier », « exposant » écrits en dur ; le vocabulaire passe par les
 * jetons {lex...}. Apostrophe typographique partout (en ICU, l'apostrophe
 * droite échappe l'accolade qui la suit).
 *
 * Mikael - chef de projet - 2026-10-05
 */
export const messagesCadeauxFr: Record<string, string> = {
  // ── Menu, titres ───────────────────────────────────────────────────────
  'adminNav.cadeaux': 'Cadeaux',
  'acces.titre.adminCadeaux': 'Cadeaux',
  'acces.titre.adminCadeauxVerifier': 'Vérifier un lot',

  // ── Roue ───────────────────────────────────────────────────────────────
  'cadeaux.roue.titre': 'La roue des cadeaux',
  'cadeaux.roue.intro': 'Merci pour vos réponses ! Voyons si un cadeau vous attend…',
  'cadeaux.roue.tourne': 'La roue tourne…',
  'cadeaux.roue.gagne': 'Bravo, vous avez gagné : {lot}',
  'cadeaux.roue.perdu': 'Vous n’avez pas gagné cette fois. Merci beaucoup pour votre participation !',
  'cadeaux.roue.passer': 'Passer l’animation',
  'cadeaux.roue.caseGagne': 'Cadeau',
  'cadeaux.roue.casePerdu': 'Merci',
  'cadeaux.roue.fermer': 'Retour aux questionnaires',

  // ── Lot gagné, carte « Mon cadeau » ────────────────────────────────────
  'cadeaux.carte.titre': 'Mon cadeau',
  'cadeaux.lot.retraitDefaut': 'À retirer à l’accueil',
  'cadeaux.lot.qrAlt': 'QR code de vérification de votre lot',
  'cadeaux.lot.qrAide': 'Montrez ce QR code (ou votre badge) à l’équipe pour retirer votre lot.',
  'cadeaux.lot.remisLe': 'Remis le {quand}',
  'cadeaux.plus.lien': 'Mon cadeau',

  // ── Back-office : en-tête et onglets ───────────────────────────────────
  'cadeaux.admin.titre': 'Cadeaux',
  'cadeaux.admin.sousTitre':
    'Les lots du jeu de la roue, les réglages, les gagnants assurés et la remise des lots.',
  'cadeaux.admin.verification': 'Vérification de vos droits…',
  'cadeaux.admin.sansDroit':
    'Cette page n’est pas ouverte à votre compte. Elle s’accorde dans Contrôle d’accès, par rôle ou par compte.',
  'cadeaux.admin.chargement': 'Chargement…',
  'cadeaux.admin.erreur': 'Impossible de charger les cadeaux. Réessayez dans un instant.',
  'cadeaux.admin.enregistre': 'Enregistré.',
  'cadeaux.admin.echec': 'L’enregistrement a échoué.',
  'cadeaux.admin.chiffres':
    '{participations, plural, =0 {Aucune participation} one {# participation} other {# participations}}, {gagnants, plural, =0 {aucun gagnant} one {# gagnant} other {# gagnants}}, {remis, plural, =0 {aucun lot remis} one {# lot remis} other {# lots remis}}',
  'cadeaux.admin.jeuEteint': 'Le jeu est éteint : aucune roue ne tourne pour le moment.',
  'cadeaux.admin.jeuAllume': 'Le jeu est actif : la roue tourne après l’envoi d’un questionnaire.',
  'cadeaux.admin.onglets': 'Rubriques des cadeaux',
  'cadeaux.admin.onglet.lots': 'Lots',
  'cadeaux.admin.onglet.reglages': 'Réglages du jeu',
  'cadeaux.admin.onglet.regles': 'Gagnants assurés',
  'cadeaux.admin.onglet.gagnants': 'Gagnants',
  'cadeaux.admin.onglet.verifier': 'Vérifier un lot',

  // ── Lots ───────────────────────────────────────────────────────────────
  'cadeaux.admin.lots.vide': 'Aucun lot pour le moment. Créez le premier ci-dessous.',
  'cadeaux.admin.lots.stock': '{restant} restants sur {total}',
  'cadeaux.admin.lots.gagnes': '{gagnes, plural, =0 {jamais gagné} one {# fois gagné} other {# fois gagné}}, {remis} remis',
  'cadeaux.admin.lots.inactif': 'Inactif',
  'cadeaux.admin.lots.modifier': 'Modifier',
  'cadeaux.admin.lots.supprimer': 'Supprimer',
  'cadeaux.admin.lots.supprimerConfirme': 'Supprimer le lot « {nom} » ?',
  'cadeaux.admin.lots.dejaGagne': 'Ce lot a déjà été gagné : désactivez-le plutôt que de le supprimer.',
  'cadeaux.admin.lots.nouveau': 'Nouveau lot',
  'cadeaux.admin.lots.edition': 'Modifier le lot « {nom} »',
  'cadeaux.admin.lots.nom': 'Nom du lot',
  'cadeaux.admin.lots.description': 'Description',
  'cadeaux.admin.lots.photo': 'Photo du lot',
  'cadeaux.admin.lots.photoBouton': 'Téléverser une photo',
  'cadeaux.admin.lots.photoOk': 'Photo téléversée.',
  'cadeaux.admin.lots.photoApercu': 'Aperçu de la photo du lot',
  'cadeaux.admin.lots.quantite': 'Quantité disponible',
  'cadeaux.admin.lots.quantiteAide': 'Elle ne peut pas descendre sous le nombre de lots déjà gagnés.',
  'cadeaux.admin.lots.sousAttribues':
    'Quantité trop basse : {attribues, plural, one {# lot a} other {# lots ont}} déjà été gagnés.',
  'cadeaux.admin.lots.actif': 'Lot actif (peut sortir à la roue)',
  'cadeaux.admin.lots.ordre': 'Ordre d’affichage',
  'cadeaux.admin.lots.enregistrer': 'Enregistrer le lot',
  'cadeaux.admin.lots.annuler': 'Annuler',

  // ── Réglages ───────────────────────────────────────────────────────────
  'cadeaux.admin.reglages.actif': 'Jeu actif',
  'cadeaux.admin.reglages.actifAide':
    'Éteint par défaut. Allumé, la roue tourne après l’envoi d’un questionnaire, tant qu’il reste des lots.',
  'cadeaux.admin.reglages.probabilite': 'Probabilité de gagner (%)',
  'cadeaux.admin.reglages.probabiliteAide': 'Les gagnants assurés passent avant ce tirage.',
  'cadeaux.admin.reglages.fin': 'Fin du jeu (facultative)',
  'cadeaux.admin.reglages.sondages': 'Questionnaires qui lancent la roue',
  'cadeaux.admin.reglages.sondagesAide': 'Aucune case cochée : tous les questionnaires publiés.',
  'cadeaux.admin.reglages.retrait': 'Consigne de retrait affichée au gagnant',
  'cadeaux.admin.reglages.retraitAide': 'Vide : « À retirer à l’accueil ».',
  'cadeaux.admin.reglages.enregistrer': 'Enregistrer les réglages',

  // ── Gagnants assurés ───────────────────────────────────────────────────
  'cadeaux.admin.regles.intro':
    'Ces personnes gagnent à tous les coups, avant le tirage au hasard. La règle la plus précise l’emporte : personne, puis profil, puis type de compte.',
  'cadeaux.admin.regles.cible': 'Qui gagne à tous les coups',
  'cadeaux.admin.regles.cible.role': 'Un type de compte',
  'cadeaux.admin.regles.cible.profil': 'Un profil',
  'cadeaux.admin.regles.cible.personne': 'Une personne nommée',
  'cadeaux.admin.regles.role': 'Type de compte',
  'cadeaux.admin.regles.profil': 'Profil',
  'cadeaux.admin.regles.recherche': 'Rechercher une personne',
  'cadeaux.admin.regles.rechercheAide': 'Deux lettres au moins : prénom, nom ou courriel.',
  'cadeaux.admin.regles.choisie': 'Personne choisie : {nom}',
  'cadeaux.admin.regles.lot': 'Lot imposé',
  'cadeaux.admin.regles.lotHasard': 'Tiré au hasard parmi les lots en stock',
  'cadeaux.admin.regles.lotAide': 'Si le lot imposé est épuisé, un autre lot en stock est donné, et c’est noté au journal.',
  'cadeaux.admin.regles.ajouter': 'Ajouter la règle',
  'cadeaux.admin.regles.vide': 'Aucun gagnant assuré.',
  'cadeaux.admin.regles.supprimer': 'Retirer',
  'cadeaux.admin.regles.ligne': '{cible} : {valeur}, {lot}',

  // ── Libellés des types de compte et des profils ────────────────────────
  'cadeaux.role.visitor': 'Visiteur ou visiteuse',
  'cadeaux.role.exhibitor': '{lexExhibitorCap}',
  'cadeaux.role.vip': 'Invité VIP',
  'cadeaux.role.specific_public': 'Public spécifique',
  'cadeaux.role.student': 'Élève ou étudiant',
  'cadeaux.role.child': 'Enfant',
  'cadeaux.role.staff': 'Équipe d’organisation',
  'cadeaux.profil.visitor': 'Visiteur ou visiteuse',
  'cadeaux.profil.exhibitor': '{lexExhibitorCap}',
  'cadeaux.profil.workshop_host': 'Animateur ou animatrice {lexWorkshopOf}',
  'cadeaux.profil.accompagnateur': 'Accompagnateur ou accompagnatrice',
  'cadeaux.profil.vip': 'Invité VIP',
  'cadeaux.profil.specific_public': 'Public spécifique',
  'cadeaux.profil.student': 'Élève ou étudiant',
  'cadeaux.profil.child': 'Enfant',
  'cadeaux.profil.staff': 'Équipe d’organisation',

  // ── Gagnants ───────────────────────────────────────────────────────────
  'cadeaux.admin.gagnants.filtreLot': 'Lot',
  'cadeaux.admin.gagnants.tousLots': 'Tous les lots',
  'cadeaux.admin.gagnants.filtreEtat': 'État',
  'cadeaux.admin.gagnants.tous': 'Tous',
  'cadeaux.admin.gagnants.aRemettre': 'À remettre',
  'cadeaux.admin.gagnants.remis': 'Remis',
  'cadeaux.admin.gagnants.export': 'Exporter en CSV',
  'cadeaux.admin.gagnants.vide': 'Aucun gagnant pour ces critères.',
  'cadeaux.admin.gagnants.col.gagnant': 'Gagnant',
  'cadeaux.admin.gagnants.col.lot': 'Lot',
  'cadeaux.admin.gagnants.col.gagneLe': 'Gagné le',
  'cadeaux.admin.gagnants.col.etat': 'État',
  'cadeaux.admin.gagnants.assure': 'gagnant assuré',
  'cadeaux.admin.gagnants.repli': 'lot imposé épuisé, repli',
  'cadeaux.admin.gagnants.remisPar': 'Remis le {quand} par {par}',
  'cadeaux.admin.gagnants.verifier': 'Vérifier',

  // ── Vérification et remise (back-office et point de contrôle) ─────────
  'cadeaux.verif.intro':
    'Le geste principal se fait au point de contrôle « remise des cadeaux » de l’équipe de scan. Cet écran sert de repli : collez l’adresse du QR ou son code.',
  'cadeaux.verif.code': 'Adresse ou code du QR',
  'cadeaux.verif.verifier': 'Vérifier',
  'cadeaux.verif.inconnu': 'QR de lot inconnu.',
  'cadeaux.verif.aRemettre': 'Gagné : {lot}, à remettre',
  'cadeaux.verif.dejaRemis': 'Déjà remis le {quand} par {par}',
  'cadeaux.verif.aucun': 'Aucun lot gagné',
  'cadeaux.verif.remis': 'Remis',
  'cadeaux.verif.remisOk': 'Lot remis.',
  'cadeaux.verif.suivant': 'Suivant',

  // ── Point de contrôle ──────────────────────────────────────────────────
  'cadeaux.controle.tag': 'remise des cadeaux',
  'cadeaux.controle.titre': 'Remise des cadeaux',
  'cadeaux.controle.aide': 'Scannez le badge de la personne ou le QR de son lot.',
  'controlTypes.nature.label': 'Nature du point de contrôle',
  'controlTypes.nature.passage': 'Passage (entrée, repas, vestiaire…)',
  'controlTypes.nature.remise_cadeaux': 'Remise des cadeaux (non compté comme un passage)',
  'controlTypes.nature.badge': 'Remise des cadeaux',
};
